import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import {
  markNotificationAsRead,
  markNotificationAsUnread,
} from "store/actions";

import { getId } from "helpers/functions";

function NotificationReadStatus({ notification }) {
  const dispatch = useDispatch();

  if (!notification.read)
    return (
      <OverlayTrigger
        overlay={
          <Tooltip placement="top">
            <FormattedMessage id="markAsRead" />
          </Tooltip>
        }
      >
        <button
          type="button"
          className="mark-as-read"
          onClick={(e) => {
            e.preventDefault();
            dispatch(markNotificationAsRead(getId(notification)));
          }}
        ></button>
      </OverlayTrigger>
    );

  return (
    <OverlayTrigger
      overlay={
        <Tooltip placement="top">
          <FormattedMessage id="markAsUnread" />
        </Tooltip>
      }
    >
      <button
        type="button"
        className="mark-as-read unread"
        onClick={(e) => {
          e.preventDefault();
          dispatch(markNotificationAsUnread(getId(notification)));
        }}
      ></button>
    </OverlayTrigger>
  );
}

export default NotificationReadStatus;
